export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.8-1148.47",
  commitId: "3595aeb2bbbd01b10e08a8c7219bf82aa5166f01",
  commitTime: "2026-10-08T11:48:47.000Z",
});
